module.exports = __webpack_public_path__ + "static/media/Facebook.10a646d7.svg";